module.exports = __webpack_public_path__ + "static/media/logosFooterComposition.84cfc57a.png";